import Hero from '../components/Hero';
import About from '../components/About';
import Contact from '../components/Contact';

export default function Home() {
  return (
    <main className="min-h-screen pt-15">
      <Hero />
      <About />
      <Contact />
    </main>
  );
}
